const email = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const number = /^[0-9]*$/;

export const REGEX_PATTERN = { email, number };
